var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBExpandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 21.5 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_53_1",
    "data-name": "Component 53 \\u2013 1",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#fff",
    stroke: "#373737",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_76",
    "data-name": "Line 76",
    x2: 8,
    transform: "translate(6 10)",
    fill: "none",
    stroke: "#373737",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_77",
    "data-name": "Line 77",
    y2: 8,
    transform: "translate(10 6)",
    fill: "none",
    stroke: "#373737",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBExpandIcon);
export default __webpack_public_path__ + "static/media/bExpandIcon.734c6f8bceea1b3a0ad7960d18eb3638.svg";
export { ForwardRef as ReactComponent };